import i18n from '@/lang'
import { getUserLanguage, setTheme, getTheme } from '@/utils/auth'
i18n.locale = getUserLanguage()
const themeList = [
  {
    title: i18n.t('public.default'),
    color: '#66b1ff',
    name: 'default'
  },
  {
    title: i18n.t('public.green'),
    color: '#66b1ff',
    name: 'green'
  }

]
const defaultTheme = themeList[0].name
const theme = {
  namespaced: true,
  state: {
    keys: 'theme',
    list: themeList,
    activeName: defaultTheme
  },
  getters: {
    activeSetting(state) {
     
      return state.list.find(theme => theme.name === state.activeName)
    }
  },
  mutations: {
    set(state, theme) {
      state.activeName = theme || defaultTheme
      setTheme(state.activeName)
      document.body.className = `theme-${state.activeName}`
    }
  },
  actions: {
    load({ commit }) {
      return new Promise(async resolve => {
        let theme = await getTheme()
        commit('set', theme)
        resolve()
      })
    },
    set({ commit }, theme) {
      commit('set', theme)
    }
  }
}
export default theme
